const translatedLocales: { [key: string]: string } = {
  he: 'iw',
  ms: 'ml',
  nb: 'no',
  'zh-Hans': 'zh-cn',
  'zh-Hant': 'zh-tw',
};

const getLocaleFromLang = (lang: string): string => translatedLocales[lang] || lang;

export default getLocaleFromLang;
